import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { 
  Bell,
  Search,
  LogOut,
  Menu
} from 'lucide-react';

const Header = ({ userType, onMobileMenuToggle }) => {
  const { user, logout } = useAuth();
  const [searchQuery, setSearchQuery] = useState('');

  return (
    <>
      {/* Top header bar */}
      <div className="lg:pl-64">
        <div className="sticky top-0 z-40 flex h-16 shrink-0 items-center gap-x-4 border-b border-gray-200 bg-white px-4 shadow-sm">
          <div className="flex flex-1 gap-x-4 self-stretch lg:gap-x-6">
            {/* Mobile menu button */}
            <div className="lg:hidden">
              <button 
                onClick={onMobileMenuToggle}
                className="text-gray-700 hover:text-gray-900"
              >
                <Menu size={24} />
              </button>
            </div>
            <h1 className="text-lg font-semibold text-gray-900 lg:hidden">DVT_HULO_SYSTEM</h1>
            
            {/* Search bar */}
            <div className="flex flex-1 items-center gap-x-4 lg:gap-x-6">
              <div className="flex flex-1 items-center gap-x-4 lg:gap-x-6">
                <div className="relative flex-1 max-w-lg">
                  <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                    <Search className="h-5 w-5 text-gray-400" />
                  </div>
                  <input
                    type="text"
                    placeholder="Tìm kiếm..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className="block w-full rounded-md border-0 py-1.5 pl-10 pr-3 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                  />
                </div>
              </div>
            </div>

            {/* Right side actions */}
            <div className="flex items-center gap-x-4 lg:gap-x-6">
              {/* Notifications */}
              <button className="text-gray-400 hover:text-gray-600">
                <Bell className="h-6 w-6" />
              </button>

              {/* User dropdown */}
              <div className="hidden lg:flex lg:items-center lg:gap-x-4">
                <div className="flex items-center">
                  <div className="flex-shrink-0">
                    {user?.avatar ? (
                      <img
                        src={user.avatar}
                        alt={user.name}
                        className="h-8 w-8 rounded-full"
                      />
                    ) : (
                      <div className="h-8 w-8 rounded-full bg-blue-600 flex items-center justify-center">
                        <span className="text-sm font-medium text-white">
                          {user?.name?.charAt(0).toUpperCase()}
                        </span>
                      </div>
                    )}
                  </div>
                  <div className="ml-3">
                    <p className="text-sm font-medium text-gray-700">{user?.name}</p>
                    <p className="text-xs text-gray-500">{user?.email}</p>
                  </div>
                </div>
                <button
                  onClick={logout}
                  className="flex items-center px-2 py-2 text-sm font-medium text-gray-600 rounded-md hover:bg-gray-50 hover:text-gray-900"
                >
                  <LogOut className="mr-2 h-4 w-4" />
                  Đăng xuất
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header; 
